<div class="container" [ngSwitch]="mode">

    <div *ngSwitchDefault>
      <div *ngIf="isLoading" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
      <table *ngIf="!isLoading" style="width:100%">
        <tr  class="back">
          <th>Service Name</th>
          <th>
            <button class="add" mat-raised-button color="basic" (click)="addNew()">
              Add New
            </button>

          </th>
          <th>
            <input type="text" class="form-control" id="search-text" aria-describedby="search-text"
            [(ngModel)]="searchText" placeholder="Search"
            autofocus
          >
          </th>
        </tr>
        <tr class="td" *ngFor="let title of filterddata">
          <td>{{title.service_name}}</td>
          <td>{{title.service_price}}</td>
          <td>
            <!-- <button mat-raised-button color="primary" (click)=" edit(title)">
              Edit
            </button> -->
            <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="delete(title)">
              Delete
            </button>
          </td>
        </tr>
      </table>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="last">
      </div>
    </div>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
      <div class="post">
        <div class="title">Create OPD Detail</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Select OPD</mat-label>
                <mat-select formControlName="pack_id" (ngModelChange)="cngPackage($event)" matNativeControl required>
                  <mat-option *ngFor="let item of opds" [value]="item.id">
                    {{item.package_name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <!-- <span class="input">
            <mat-form-field>
                <mat-label>Service</mat-label>
                <mat-select formControlName="service_name" matNativeControl required>
                  <mat-option *ngFor="let item of items" [value]="item.name">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span> -->
          <span style="width: 100px;">
            <mat-form-field style="width: 200px;">
                <mat-label>Service</mat-label>
                <input [(ngModel)]="itemName" (ngModelChange)="refchg($event)" matInput [ngModelOptions]="{standalone: true}">
                <div class="float" style="position: relative; width: 3px;">
                  <div class="ret" *ngIf="visible">
                    <!-- <div class="list" *ngIf="refLoad" >Loading</div> -->
                    <div class="list" (click)="setItem(item)" *ngFor="let item of serchItems">{{item.name}}</div>
                  </div>
                </div>
              </mat-form-field>
          </span>
          <span style="width: 100px;">
            <mat-form-field style="width: 100px; margin-left: 20px;">
                <mat-label>Discount (%)</mat-label>
                <input [(ngModel)]="discount" (change)="onChange($event)" matInput [ngModelOptions]="{standalone: true}">
              </mat-form-field>
          </span>
          <span>
            <button class="create" type="button" mat-raised-button color="primary" style="margin-left: 50px;" (click)="add()">Add</button>
          </span>
          <div class="table">
            <div class="service" (click)="deleteItem(service.service_id)" *ngFor="let service of lstServices">{{service.service_name}}<br>
              {{service.net_amt}}
            </div>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" type="submit" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
          <button class="create" (click)="dlt()" style="margin-left: 20px;" mat-raised-button color="primary">
            Delete Packages
          </button>
        </div>
      </div>
    </form>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'edit'">
      <div class="post">
        <div class="title">Edit OPD Detail</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Select OPD</mat-label>
                <mat-select formControlName="pack_id" matNativeControl required>
                  <mat-option *ngFor="let item of opds" [value]="item.id">
                    {{item.package_name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
            <span class="input">
                <mat-form-field>
                    <mat-label>Service</mat-label>
                    <mat-select formControlName="service_name" matNativeControl required>
                      <mat-option *ngFor="let item of items" [value]="item.name">
                        {{item.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Price</mat-label>
                    <input formControlName="service_price" matInput placeholder="Imo">
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Discount %</mat-label>
                    <input formControlName="discount_percent" matInput placeholder="Imo">
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Discount Price</mat-label>
                    <input formControlName="discount_price" matInput placeholder="Imo">
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Net Amount</mat-label>
                    <input formControlName="net_amt" matInput placeholder="Imo">
                  </mat-form-field>
              </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
          <button class="create" (click)="dlt()" style="margin-left: 20px;" mat-raised-button color="primary">
            Delete Packages
          </button>
        </div>
      </div>
    </form>

    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'delete'">
      <div class="post">
        <div class="title">Delete Itmes</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Select OPD</mat-label>
                <mat-select formControlName="pack_id" (ngModelChange)="cngPackage($event)" matNativeControl required>
                  <mat-option *ngFor="let item of opds" [value]="item.id">
                    {{item.package_name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <!-- <span class="input">
            <mat-form-field>
                <mat-label>Service</mat-label>
                <mat-select formControlName="service_name" matNativeControl required>
                  <mat-option *ngFor="let item of items" [value]="item.name">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span> -->
          <span style="width: 100px;">
            <mat-form-field style="width: 200px;">
                <mat-label>Service</mat-label>
                <input [(ngModel)]="itemName" (ngModelChange)="refchg($event)" matInput [ngModelOptions]="{standalone: true}">
                <div class="float" style="position: relative; width: 3px;">
                  <div class="ret" *ngIf="visible">
                    <!-- <div class="list" *ngIf="refLoad" >Loading</div> -->
                    <div class="list" (click)="setItem(item)" *ngFor="let item of serchItems">{{item.name}}</div>
                  </div>
                </div>
              </mat-form-field>
          </span>
          <span style="width: 100px;">
            <mat-form-field style="width: 100px; margin-left: 20px;">
                <mat-label>Discount (%)</mat-label>
                <input [(ngModel)]="discount" (change)="onChange($event)" matInput [ngModelOptions]="{standalone: true}">
              </mat-form-field>
          </span>
          <span>
            <button class="create" type="button" mat-raised-button color="primary" style="margin-left: 50px;" (click)="add()">Add</button>
          </span>
          <div class="table">
            <div class="service" (click)="deleteDetail(service.id, service.pack_id)" *ngFor="let service of packages">{{service.service_name}}<br>
              {{service.net_amt}}
            </div>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" (click)="back()" style="margin-left: 20px;" mat-raised-button color="primary">
            Back
          </button>
        </div>
      </div>
    </form>


    </div>
